export enum WhoOptionsYesNoNone {
    Yes = 1,
    No = 2,
    None_Of_The_Above = 3
}
